import { Tooltip, Box } from "@mui/material"
import { Projeto } from "src/components/projetos/types"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"

interface InputKwhComImpostoProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
}

function InputKwhComImposto({ formState, setFormState }: InputKwhComImpostoProps) {
  return (
    <Tooltip arrow title="Enquanto kWp é usado para medir a potência máxima de um sistema; kWh é usado para medir a quantidade de eletricidade que o sistema produz.">
      <Box>
        <InputDecimal3
          InputLabelProps={{ shrink: true }}
          label={`Preço do kWh com imposto`}
          margin="normal"
          decimal={2}
          disabled
          placeholder="R$ 0,00"
          maxLength={15}
          prefix={!formState.isTrocaUf && formState.preco_kwh_com_imposto ? <>R$&nbsp;</> : ''}
          value={!formState.isTrocaUf ? String(formState.preco_kwh_com_imposto || '') : ''}
          onChange={(event: any) => {
            const normalized = event.target.value ? event.target.value.replace(',', '.') : ''
            setFormState({ preco_kwh_com_imposto: normalized })
          }}
          />
      </Box>
    </Tooltip>
  )
}

export { InputKwhComImposto }